import React from 'react';
import { formatPercent } from '../lib/executiveCommandCenterFormatters';

const ActivationPipelinePanel = ({ data }) => {
  const info = data || {};

  return (
    <section className="rounded-2xl border border-slate-800 bg-slate-900/60 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Activation / Installation Pipeline</h3>
      <div className="mt-3 grid gap-3 md:grid-cols-4 xl:grid-cols-8">
        <Tile label="Registrasi Hari Ini" value={Number(info.new_registrations_today || 0)} tone="text-cyan-200" />
        <Tile label="Registrasi Minggu Ini" value={Number(info.new_registrations_week || 0)} tone="text-cyan-300" />
        <Tile label="Survey Pending" value={Number(info.survey_pending || 0)} tone="text-amber-200" />
        <Tile label="Approval Pending" value={Number(info.approval_pending || 0)} tone="text-amber-300" />
        <Tile label="Instalasi Progress" value={Number(info.installation_in_progress || 0)} tone="text-blue-300" />
        <Tile label="Activation Ready" value={Number(info.activation_ready || 0)} tone="text-indigo-300" />
        <Tile label="Blocked/Revision" value={Number(info.blocked_or_revision || 0)} tone="text-red-300" />
        <Tile label="Success Rate" value={formatPercent(info.activation_success_rate)} tone="text-emerald-200" />
      </div>
    </section>
  );
};

const Tile = ({ label, value, tone }) => (
  <div className="rounded-lg border border-slate-800 bg-slate-950/70 p-3">
    <div className="text-xs text-slate-400">{label}</div>
    <div className={`mt-1 text-lg font-semibold ${tone}`}>{value}</div>
  </div>
);

export default ActivationPipelinePanel;
